export default 'myInfo';